const errorNames = {
  STAGED_HANDLER_ABORT_ERROR: 'StagedHandlerAbortError',
};

export default errorNames;
